module.exports = __webpack_public_path__ + "img/game_bg1.c6deeed7.png";